import { c as _c } from "react/compiler-runtime";
function escapeRegExp(text: string) {
  return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
type HighlightTextProps = {
  text: string;
  highlight: string;
  highlightColor?: string;
  className?: string;
};
export function HighlightText(t0) {
  const $ = _c(18);
  const {
    text,
    highlight,
    highlightColor: t1,
    className
  } = t0;
  const highlightColor = t1 === undefined ? "#FF9E24" : t1;
  if (!highlight || !text.includes(highlight)) {
    let t2;
    if ($[0] !== className || $[1] !== text) {
      t2 = <span className={className}>{text}</span>;
      $[0] = className;
      $[1] = text;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== highlight) {
    t2 = escapeRegExp(highlight);
    $[3] = highlight;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const escapedHighlight = t2;
  let t3;
  let t4;
  if ($[5] !== className || $[6] !== escapedHighlight || $[7] !== highlight || $[8] !== highlightColor || $[9] !== text) {
    const regex = new RegExp(`(${escapedHighlight})`, "g");
    const parts = text.split(regex);
    t3 = className;
    let t5;
    if ($[12] !== highlight || $[13] !== highlightColor) {
      t5 = (part, index) => part === highlight ? <span key={index} style={{
        color: highlightColor
      }}>{part}</span> : <span key={index}>{part}</span>;
      $[12] = highlight;
      $[13] = highlightColor;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = parts.map(t5);
    $[5] = className;
    $[6] = escapedHighlight;
    $[7] = highlight;
    $[8] = highlightColor;
    $[9] = text;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}